import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { serviceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/casi-uso/avvocato-singolo")({
  head: () => seoMeta({
    title: "LexAIPro per avvocati singoli",
    description: "L'avvocato individuale risparmia in media 12 ore a settimana usando LexAIPro per ricerca, analisi e redazione.",
    path: "/casi-uso/avvocato-singolo",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[serviceSchema({ name: "LexAIPro per l'avvocato singolo", description: "Soluzione AI pensata per il professionista individuale: ricerca, analisi e redazione in autonomia.", path: "/casi-uso/avvocato-singolo", category: "Legal AI" })]}
      eyebrow="Casi d'uso"
      title="LexAIPro per l'avvocato singolo"
      lead="Lavorare da solo significa fare tutto. LexAIPro è il junior che non hai: ricerca, sintetizza atti, redige bozze e ti restituisce il tempo per i clienti."
      tldr="Stima media: 12 ore/settimana risparmiate, 3× più pratiche gestite, costo inferiore a una consulenza esterna mensile."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Casi d'uso",path:"/casi-uso/avvocato-singolo"},{name:"Avvocato singolo",path:"/casi-uso/avvocato-singolo"}]}
      sections={[
        { heading: "Cosa cambia con LexAIPro", bullets: ["Ricerca giurisprudenziale in minuti, non ore","Prima bozza di un atto in 5 minuti","Sintesi di un fascicolo in pochi secondi","Calendario scadenze automatico"] },
        { heading: "Piano consigliato", body: "Starter (79 €/mese) o Professional (199 €/mese) per query illimitate." },
      ]}
      cta={{ label: "Inizia ora", to: "/signup" }}
      heroImage={pickContent(17)}
      updated="2026"
    />
  ),
});
